<template>
  <div class="waiting-overlay" v-if="value">
    <div class="waiting-overlay-mask"></div>
    <div class="waiting-overlay-body">
      <v-card color="#1DA7FC" dark>
        <v-card-text>
          資料傳送中，請稍候
          <v-progress-linear
            indeterminate
            color="white"
            class="mb-0"
          ></v-progress-linear>
        </v-card-text>
      </v-card>
    </div>
  </div>
</template>

<script>
export default {
  name: 'WaitingOverlay',
  props: {
    value: {
      type: Boolean,
      default: false,
    },
  },
  computed: {},
  methods: {},
  mounted: function() {},
}
</script>

<style scoped>
.waiting-overlay {
  position: fixed;
  top: 0;
  bottom: 0;
  right: 0;
  left: 0;
  z-index: 500;
  display: flex;
  justify-content: center;
  flex-direction: column;
}
.waiting-overlay-mask {
  opacity: 0.3;
  background-color: black;
  position: absolute;
  top: 0;
  bottom: 0;
  right: 0;
  left: 0;
}
</style>
